export default {
  methods : {
    convertToFormattedNumber(value, fixedPoint = 1) {
        if(value == null) return ""
        var num = new Number(value)
        var formattedValue = num.toFixed(fixedPoint).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        if(formattedValue.substring(formattedValue.length - fixedPoint, formattedValue.length) == '0') {
          return formattedValue.substring(0, formattedValue.length - 2)
        }
        return formattedValue
    }
  }
}